// This service is used to share data among the application
function dataService () {
  var dataService = {}

  // used by draggable and droppable directives
  // to exchange data between directives
  dataService.onDropFunction = null

  return dataService
}

export { dataService }
